<!-- 这是试题类型 -->
<template>
    <div>
        <el-form :model="searchData" label-width="80px">
            <el-col :span="24">
                <el-form-item label="题干">
                    <el-input type="textarea" v-model="searchData.name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="24" class="text">
                <el-col :span="4"><p>选项</p></el-col>
                <el-col :span="12"><p>选项内容</p></el-col>
                <el-col :span="4"><p>正确答案</p></el-col>
                <el-col :span="4"><el-button type="primary" @click="addOptions" size="small">添加选项</el-button></el-col>
            </el-col>
            <el-col :span="24" class="text" v-for="item in options" :key="item.number">
                <el-col :span="4"><p>{{Number(item.number) | change}}</p></el-col>
                <el-col :span="12"><el-input v-model="item.option"></el-input></el-col>
                <el-col :span="4"><el-checkbox v-model="item.answer"></el-checkbox ></el-col>
                <el-col :span="4"><el-button type="danger" @click="delOptions(item)" size="small">删除</el-button></el-col>
            </el-col>
            <el-col :span="24">
                <el-form-item label="标签">
                    <el-radio v-model="searchData.question_difficulty" v-for="item in difficulty" :label="item.id" :key="item.id">{{item.name}}</el-radio>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="解析">
                    <el-input type="textarea" v-model="searchData.introduce" :autosize="{ minRows: 2, maxRows: 6}"></el-input>
                </el-form-item>
            </el-col>
        </el-form>

    </div>
</template>

<script>

import filters from '@/api/filters.js' //局部引入过滤器
export default {
    filters:filters,
    props:['dialogData','uploadType'],
    data(){
        return{
            searchData: {},//收集页面数据
            difficulty:[
                {id:1,name:'难'},
                {id:2,name:'中'},
                {id:3,name:'易'},
            ],
            options:[],
            num:1,//下标
        }
    },
    methods:{
        init(){
            if(this.dialogData && this.dialogData.details){
                this.searchData = {
                    name:this.dialogData.details.name,
                    introduce:this.dialogData.details.introduce,
                    question_difficulty:this.dialogData.details.question_difficulty
                }
                if(this.dialogData.details.options){
                    this.options = JSON.parse(this.dialogData.details.options)
                    this.options.forEach(item =>{
                        if(item.answer == 1){
                            item.answer = true
                        }
                    })
                }
            }else{
                this.searchData = {
                    name:'',
                    introduce:'',
                    question_difficulty:'',
                }
            }
        },
        //新增选项
        addOptions(){
            if(this.options.length <= 5){
                let json = {
                    number:this.options.length,
                    option:'',
                    answer:0
                }
                this.options.push(json)
                this.num++
            }else{
                this.$message.error('最多可以增加6个选择项');
            }
        },
        //删除选项
        delOptions(data){
            this.options.forEach((element,index) => {
                if(element.number == data.number){
                    this.options.splice(index,1)
                    this.num--
                }
            });
            this.options.forEach((item,index) => {
                item.number = index
            });
        },
        clearData(){
            this.searchData = {}
            this.options = []
        },
        submit(){
            let tag = 0
            let num = ''
            this.options.forEach(element => {
                element.number  = Number(element.number)
                if(element.answer == true){
                    element.answer = 1
                    tag++
                }else {
                  element.answer = 0
                }
                num += element.answer
            });
            if(tag > 1){
                this.searchData.question_type = '2'
            }else{
              if(this.options.length>2){
                this.searchData.question_type = '1'
              }else if(this.options.length === 2){
                this.searchData.question_type = '3'
              }
            }
            this.searchData['answer'] = parseInt(num,2)
            this.searchData.options = this.options
        }
    },
    watch:{
        dialogData:{
            handler(nerVal) {
                this.init()
            },
            deep: true,
            immediate: true,
        }
    }
}
</script>

<style scoped>
.text .el-col{text-align: center;}
.text p{line-height: 40px; color: #606266;}
.text .el-checkbox{margin-top: 10px;}

</style>
